import React from 'react';
import { cn } from '../../../lib/cn';
import { Radio, Checkbox } from '../atoms';

/**
 * OptionRow, the 44px tappable row holding a radio or checkbox.
 *
 * CSS selector: `mobile/molecules.css` `.ds-option-row`, with
 * `.ds-option-row__label` and `.ds-option-row__count`.
 *
 * Doctrine: this formalises the rule that a bare radio or checkbox is always
 * wrapped. The label is the 44px hit target and the control keeps its exact
 * 22px size, so bigness comes from row padding rather than from inflating the
 * control. Selection stays accent, because the control marks state.
 *
 * `control` picks which atom renders. `leading` is a slot between the control
 * and the label for things like an abbreviation `<Tag variant="abbrev">`.
 */
export const OptionRow = React.forwardRef(function OptionRow(
  { className, control = 'radio', label, count, leading, disabled = false, inputProps, ...rest },
  ref,
) {
  const Control = control === 'checkbox' ? Checkbox : Radio;

  return (
    <label
      ref={ref}
      aria-disabled={disabled || undefined}
      className={cn('ds-option-row', className)}
      {...rest}
    >
      <Control disabled={disabled} {...inputProps} />
      {leading}
      <span className="ds-option-row__label">{label}</span>
      {count === undefined ? null : <span className="ds-option-row__count">{count}</span>}
    </label>
  );
});

export default OptionRow;
